import React from 'react'

const markerSvg = ({ className, children }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="46"
    height="46"
    viewBox="0 0 24 24"
    role="presentation"
    aria-hidden="true"
    className={className}
  >
    <path d="M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z" />
    <text textAnchor="middle" x="12" y="14" fill="#FFFFFF" fontSize="0.7em">
      {`${children}`}
    </text>
  </svg>
)

export default markerSvg
